import { createSelector } from 'reselect';
import HandlerMailRegistrationDeviceDeliverySummaryColumns from '../../containers/HandlerMailRegistrationDeviceDeliverySummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, HandlerMailRegistrationDeviceDeliverySummaryColumns);
